export default function Skills() {
    return (
        <>
            <p>Underconstruction</p>
        </>
    )
}